import React from "react";
import { Globe2, TrendingUp, TrendingDown } from "lucide-react";
import { fmtDelta } from "../../lib/game";

const Curve = ({ points }) => {
  if (!points.length) return <p className="text-xs text-slate-500">No repeat games yet.</p>;
  const max = Math.max(1, ...points.map((p) => Math.abs(p.avg_change)));
  return (
    <div className="flex items-end gap-1.5 h-16">
      {points.map((p) => (
        <div key={p.game} className="flex-1 flex flex-col items-center gap-1" title={`Game ${p.game}: ${fmtDelta(p.avg_change)} (${p.players} players)`}>
          <div
            className={`w-full rounded-md ${p.avg_change >= 0 ? "bg-emerald-400/80" : "bg-rose-400/80"}`}
            style={{ height: `${Math.max(6, (Math.abs(p.avg_change) / max) * 48)}px` }}
          />
          <span className="text-[10px] font-mono text-slate-500">G{p.game}</span>
        </div>
      ))}
    </div>
  );
};

const CountryCard = ({ c }) => {
  const up = c.avg_improvement >= 0;
  const Trend = up ? TrendingUp : TrendingDown;
  return (
    <div data-testid={`country-improvement-${c.country}`} className="rounded-2xl border border-slate-800 bg-slate-950/50 p-4">
      <div className="flex items-center justify-between">
        <p className="font-semibold text-slate-100">{c.name}</p>
        <span className="font-mono text-[10px] tracking-widest text-slate-500 whitespace-nowrap">{c.games} games</span>
      </div>
      <div className="mt-2 flex items-center gap-2">
        <Trend className={`w-4 h-4 ${up ? "text-emerald-400" : "text-rose-400"}`} />
        <span data-testid={`country-avg-improvement-${c.country}`} className={`font-mono font-bold whitespace-nowrap ${up ? "text-emerald-300" : "text-rose-300"}`}>
          {fmtDelta(c.avg_improvement)}
        </span>
        <span className="text-xs text-slate-500">first → latest game</span>
      </div>
      <p className="text-xs text-slate-400 mt-1">
        {c.returning_players} returning players · {c.improved_pct}% improved
      </p>
      <div className="mt-3">
        <Curve points={c.curve} />
      </div>
    </div>
  );
};

export const CountryImprovement = ({ data, days }) => (
  <div className="rounded-3xl border border-slate-800 bg-slate-900/70 p-5 mt-4" data-testid="admin-country-improvement">
    <h3 className="font-heading text-lg font-bold text-slate-100 mb-1 flex items-center gap-2">
      <Globe2 className="w-4 h-4 text-teal-400" /> Improvement by country
    </h3>
    <p className="text-xs text-slate-500 mb-4">
      How returning players' per-game result changes over repeat games {days ? `(last ${days} days)` : "(all time)"}. Bars show average gain per game number, in pound-equivalent # so countries compare fairly.
    </p>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5 gap-3">
      {(data || []).map((c) => <CountryCard key={c.country} c={c} />)}
    </div>
  </div>
);
